import type { Role } from '@/pages/users/types/rbac';

/**
 * Unify Admin–only System Integrations (email test). Matches assigned
 * `unify-admin` on the profile **or** the session display role. PractitionerRole-only
 * assignment is still authorized by the bot; UI `availableRoles` does not hydrate
 * PractitionerRole codes.
 */
export function canAccessSystemIntegrationsSettings(
  availableRoles: readonly string[],
  displayUserRole?: string,
): boolean {
  if (displayUserRole === 'Unify Admin') return true;
  return availableRoles.includes('unify-admin' satisfies Role);
}
